export const DROPDOWN_BRAZIL_STATES = [
  { value: '', label: 'Selecione' },
  { value: 'AC', label: 'Acre - AC' },
  { value: 'AL', label: 'Alagoas - AL' },
  { value: 'AP', label: 'Amapá - AP' },
  { value: 'AM', label: 'Amazonas - AM' },
  { value: 'BA', label: 'Bahia - BA' },
  { value: 'CE', label: 'Ceará - CE' },
  { value: 'DF', label: 'Distrito Federal - DF' },
  { value: 'ES', label: 'Espírito Santo - ES' },
  { value: 'GO', label: 'Goiás - GO' },
  { value: 'MA', label: 'Maranhão - MA' },
  { value: 'MT', label: 'Mato Grosso - MT' },
  { value: 'MS', label: 'Mato Grosso do Sul - MS' },
  { value: 'MG', label: 'Minas Gerais - MG' },
  { value: 'PA', label: 'Pará - PA' },
  { value: 'PB', label: 'Paraíba - PB' },
  { value: 'PR', label: 'Paraná - PR' },
  { value: 'PE', label: 'Pernambuco - PE' },
  { value: 'PI', label: 'Piauí - PI' },
  { value: 'RJ', label: 'Rio de Janeiro - RJ' },
  { value: 'RN', label: 'Rio Grande do Norte - RN' },
  { value: 'RS', label: 'Rio Grande do Sul - RS' },
  { value: 'RO', label: 'Rondônia - RO' },
  { value: 'RR', label: 'Roraima - RR' },
  { value: 'SC', label: 'Santa Catarina - SC' },
  { value: 'SP', label: 'São Paulo - SP' },
  { value: 'SE', label: 'Sergipe - SE' },
  { value: 'TO', label: 'Tocantins - TO' }
]

export const DROPDOWN_ORGAN_TYPE = [
  { value: '', label: 'Selecione' },
  { value: 'Autarquia Estadual', label: 'Autarquia Estadual' },
  { value: 'Autarquia Federal', label: 'Autarquia Federal' },
  { value: 'Autarquia Municipal', label: 'Autarquia Municipal' },
  { value: 'Câmara / Assembleia Legislativa', label: 'Câmara / Assembleia Legislativa' },
  { value: 'Câmara dos Deputados', label: 'Câmara dos Deputados' },
  { value: 'Consórcio Público', label: 'Consórcio Público' },
  { value: 'Empresa Pública', label: 'Empresa Pública' },
  { value: 'Fundação de Apoio', label: 'Fundação de Apoio' },
  { value: 'Governo do Estado', label: 'Governo do Estado' },
  { value: 'Ministério', label: 'Ministério' },
  { value: 'Ministério Público / Defensoria', label: 'Ministério Público / Defensoria' },
  { value: 'Prefeitura', label: 'Prefeitura' },
  { value: 'Presidência da República', label: 'Presidência da República' },
  { value: 'Secretaria de Estado', label: 'Secretaria de Estado' },
  { value: 'Secretaria Municipal', label: 'Secretaria Municipal' },
  { value: 'Senado Federal', label: 'Senado Federal' },
  { value: 'Sociedade de Economia Mista', label: 'Sociedade de Economia Mista' },
  { value: 'Tribunal', label: 'Tribunal' },
  { value: 'Outro', label: 'Outro' }
]

export const VERTICAIS_OPTIONS = [
  { id: 'cidadania', label: 'Cidadania e Assistência Social' },
  { id: 'cultura', label: 'Cultura, Turismo, Esporte e lazer' },
  { id: 'educacao', label: 'Educação' },
  { id: 'financeiro', label: 'Financeiro e Econômico' },
  { id: 'gestaoPublica', label: 'Gestão Pública' },
  { id: 'habitacao', label: 'Habitação e Urbanismo' },
  { id: 'infraestrutura', label: 'Infraestrutura e Mobilidade' },
  { id: 'legal', label: 'Legal e Regulatório' },
  { id: 'meioAmbiente', label: 'Meio Ambiente e Sustentabilidade' },
  { id: 'saude', label: 'Saúde' },
  { id: 'seguranca', label: 'Segurança Pública e Defesa Civil' },
  { id: 'solucoes', label: 'Soluções Administrativas' }
]

export const OBJETIVOS_OPTIONS = [
  { id: 'diagnostico', label: 'Diagnóstico & Maturidade de Inovação' },
  { id: 'acesso', label: 'Acesso às Startups' },
  { id: 'laboratorio', label: 'Estruturar Laboratório e/ou Hub de Inovação' },
  { id: 'chamada', label: 'Realizar chamada pública' },
  { id: 'capacitacao', label: 'Capacitação' },
  { id: 'networking', label: 'Networking institucional' },
  { id: 'desenvolver', label: 'Desenvolver soluções inovadoras' },
  { id: 'consultoria', label: 'Consultoria de Gestão da Inovação' }
]

export const DROPDOWN_POPULATION_SIZE = [
  { value: '', label: 'Selecione' },
  { value: 'pequeno_porte', label: 'Pequeno Porte - Até 50.000 habitantes' },
  { value: 'medio_porte', label: 'Médio Porte - De 50.001 a 100.000 habitantes' },
  { value: 'grande_porte', label: 'Grande Porte - De 100.001 a 900.000 habitantes' },
  { value: 'metropole', label: 'Metrópole - Acima de 900.000 habitantes' }
]

export const MARCO_LEGAL_OPTIONS = [
  { id: 'cpsi', label: 'CPSI' },
  { id: 'encomendaTecnologica', label: 'Encomenda Tecnológica' },
  { id: 'sandbox', label: 'Sandbox' },
  { id: 'dialogoCompetitivo', label: 'Diálogo Competitivo' },
  { id: 'licitacaoEspecial', label: 'Licitação Especial de Inovação' },
  { id: 'naoRealizou', label: 'Não realizou' }
]
